export default __webpack_public_path__ + "static/Chart1-LG@2x-957ac0ca57aeb01676f7eff5f01b0e3c.png";